<div id="site" class="d-flex align-items-center bg-auth border-top border-top-2 border-primary h-100">

  <div class="container" *ngIf="!isLinkValid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7 col-xl-4 my-5">

        <!-- Heading -->
        <h1 class="display-4 text-center mb-3">
          Der Link ist ungültig
        </h1>
        <p>
          Bitte prüfen Sie, dass der Link korrekt eingegeben ist und noch nicht zur Registrierung verwendet wurde.
        </p>
        <p>
          <a routerLink="/login" class="form-text small text-muted">
            Zum Login
          </a>
        </p>
      </div>
    </div>
  </div>


  <div class="container" *ngIf="isLinkValid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7 col-xl-4 my-5">

        <!-- Heading -->
        <h1 class="display-4 text-center mb-3">
          Registrierung
        </h1>

        <!-- Subheading -->
        <p class="text-muted text-center mb-5">
          Herzlich Willkommen.
        </p>

        <!-- Form -->
        <form>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">

                <!-- Label -->
                <label>Anrede</label>

                <!-- Input -->
                <select name="gender" [(ngModel)]="gender" class="form-control" data-toggle="select">
                  <option value="m">Herr</option>
                  <option value="f">Frau</option>
                </select>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <!-- Email address -->
              <div class="form-group">

                <!-- Label -->
                <label>Vorname</label>

                <!-- Input -->
                <input type="text" name="firstName" [(ngModel)]="firstName" class="form-control" placeholder="Vorname">

              </div>

            </div>
            <div class="col-md-6">
              <!-- Email address -->
              <div class="form-group">

                <!-- Label -->
                <label>Nachname</label>

                <!-- Input -->
                <input type="text" name="lastName" [(ngModel)]="lastName" class="form-control" placeholder="Nachname">

              </div>

            </div>
          </div>



          <!-- Email address -->
          <div class="form-group">

            <!-- Label -->
            <label>E-Mail</label>

            <!-- Input -->
            <input type="email" name="eMail" [(ngModel)]="eMail" class="form-control bg-readonly" placeholder="name@address.com" readonly>

          </div>

          <!-- Password -->
          <div class="form-group">
            <div class="row">
              <div class="col">
                <!-- Label -->
                <label>Passwort</label>
              </div>
            </div>
            <div class="input-group input-group-merge">
              <!-- Input -->
              <!--<input type="password" name="password" [(ngModel)]="password" class="form-control form-control-appended"
                     minlength="{{pwdMinLength}}" [pattern]="pwdPattern" #pwd="ngModel" placeholder="Passwort eingeben">-->

              <input [type]="passwordTextType ? 'text' : 'password'" class="form-control form-control-appended"
                     name="password" [(ngModel)]="password" placeholder="Passwort eingeben">

              <!-- Icon -->
              <!--<div class="input-group-append">
                <span class="input-group-text">
                  <i class="fe fe-eye"></i>
                </span>
              </div>-->

              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa" [ngClass]="{
                              'fa-eye-slash': !passwordTextType,
                              'fa-eye': passwordTextType
                            }" (click)="toggleFieldTextType('P')"></i>
                </span>
              </div>
            </div>

            <!--<div *ngIf="pwd.errors" class="m-t-5">
              <div class="alert alert-danger" *ngIf="(pwd.errors.minlength || pwd.errors.pattern)">
                {{pwdErrorMsg}}
              </div>
            </div>-->
          </div>

          <!-- Password retype -->
          <div class="form-group">
            <div class="input-group input-group-merge">
              <!-- Input -->
              <!--<input type="password" name="passwordRetype" [(ngModel)]="passwordRetype"
                     class="form-control form-control-appended" placeholder="Passwort bestätigen">-->

              <input [type]="confirmPasswordTextType ? 'text' : 'password'" class="form-control form-control-appended"
                     name="passwordRetype" [(ngModel)]="passwordRetype" placeholder="Passwort bestätigen">

              <!-- Icon -->
              <!--<div class="input-group-append">
                <span class="input-group-text">
                  <i class="fe fe-eye"></i>
                </span>
              </div>-->
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa" [ngClass]="{
                              'fa-eye-slash': !confirmPasswordTextType,
                              'fa-eye': confirmPasswordTextType
                            }" (click)="toggleFieldTextType('COP')"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="alert alert-danger" *ngIf="error">
            {{error}}
          </div>

          <!-- Submit -->
          <button class="btn btn-lg btn-block btn-primary mb-3" (click)="submit()">
            Registrieren
          </button>


          <!-- Link -->
          <!--
            <div class="text-center">
              <small class="text-muted text-center">
                Don't have an account yet? <a href="sign-up.html">Sign up</a>.
              </small>
            </div
          -->

        </form>

      </div>
    </div> <!-- / .row -->
  </div>

</div>
